module.exports = __webpack_public_path__ + "img/location-icon.d5468405.svg";